import { Tooltip } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Select from 'react-select';

import FabricComposition from '@components/commonFilters/materials/Fabrics/FabricComposition';
import FabricSubCategory from '@components/commonFilters/materials/Fabrics/FabricSubCategory';
import Gsm from '@components/commonFilters/materials/Fabrics/Gsm';
import MaterialName from '@components/commonFilters/materials/Fabrics/MaterialName';
import CountryFlag from '@components/CountryFlag';
import CustomDropdown from '@components/CustomDropdown';
import ImportedTag from '@components/ImportedTag';
import LoaderComponent from '@components/LoaderComponent';
import AddFabric from '@components/materials/AddFabric';
import ModalContainer from '@components/modals/ModalContainer';
import { toastError, toastSuccess } from '@components/Toast';

import AddedColors from '@features/materials/components/AddedColors';
import Fabric from '@features/materials/components/Fabric';
import TrimsAndAccessories from '@features/materials/components/TrimsAndAccessories';

import { fetchProductInfo } from '@store/actions/DesignToolAction';
import { setFilters } from '@store/common/action';
import { initialFilters } from '@store/common/reducer';
import { fetchProductMaterials, getBrands, getCollections } from '@store/design/action';
import { fetchPinnedMaterials } from '@store/material/action';
import {
	getAllBrands,
	getAllCollections,
	getAllSuppliersMaterials,
	getCommonFilters,
	getPinnedMaterials,
	getProductMatrials
} from '@store/reducers';
import { fetchAllSuppliersMaterials } from '@store/supplier/action';
import * as actionTypes from '@store/supplier/action-types';

import ApiClient from '@lib/apiClient';

import {
	enumObj,
	extraSorting,
	fetchCategoriesForTrimsOrAccessories,
	fetchTagsForTrimsOrAccessories,
	formatPairMaterialApiResponse,
	getConsumptionShortUnit,
	getConsumptionUnitForTrimsAccessories,
	getSorting,
	getTabName,
	MATERIAL_TAG_TYPE,
	MATERIAL_TITLE_NAME,
	setCardNameInfo,
	whichUserMaterialBookedCheck
} from '@utils/MaterialsUtil';
import {
	_getKey,
	checkPrimaryUserType,
	getCountryList,
	getShortName,
	getUserInfo,
	printApiError,
	validateFloatNumber
} from '@utils/Util';

import { MATERIALS_TYPE } from '@/constants/constant';

import { getPairMaterialListForProduct } from '@/services/materialService';
import { closeLoader, openLoader } from '@/store/actions/LoaderAction';
import RestrictedInfo from '@/features/materials/components/RestrictedInfo';
import CommonImage from '@/components/CommonImage';

import { useGetMachingCountQuery } from '../api/designDetailsApi';

const MaterialsLeftPanel = ({
	isShowMaterial,
	onSetShowMaterial,
	isMainFabric,
	isShowPin = true,
	requestFrom,
	callback,
	visibleTabs = [
		MATERIALS_TYPE.FABRIC,
		MATERIALS_TYPE.TRIMS_ACCESSORIES,
		MATERIALS_TYPE.BRANDING,
		'MATCHING',
		'PINNED'
	],
	isLoading,
	setIsLoading,
	selectedType,
	setSelectedType,
	isInventory,
	setIsInventory,
	availabilityStatus,
	isBuyerSelected
}) => {
	const [isHide, setIsHide] = useState(false);
	const [isAddLoading, setIsAddLoading] = useState(false);
	const [page, setPage] = useState(0);
	const [showMaterialModal, setMaterialModal] = useState(false);
	const [materialLists, setMaterialLists] = useState({});
	const [isClearAll, setIsClearAll] = useState(false);
	const [searchCollection, setSearchCollection] = useState('');
	const [selectedCollectionName, setSelectedCollectionName] = useState('');
	const [tags, setTags] = useState([]);
	const [hasNext, setHasNext] = useState(false);
	const [isApiCallRunning, setIsApiCallRunning] = useState(false);
	const [finishAndWash, setFinishAndWash] = useState([]);
	const [characteristic, setCharacteristic] = useState([]);
	const [bookedQuantityInfo, setBookedQuantityInfo] = useState({});

	const [categories, setCategories] = useState([]);
	const [selectedCategories, setSelectedCategories] = useState(null);
	const [selectedCountry, setSelectedCountry] = useState({ id: null, value: 'All' });
	const [materialQualityList, setMaterialQualityList] = useState([]);
	const [selectedMaterialQuality, setSelectedMaterialQuality] = useState(null);

	const [selectedSpecificBrand, setSelectedSpecificBrand] = useState({});
	const refMaterialSearchName = useRef('');
	const dispatch = useDispatch();
	const { id } = useParams();
	const materialsData = useSelector(getAllSuppliersMaterials);
	const pinnedMaterials = useSelector(getPinnedMaterials);
	const commonFilters = useSelector(getCommonFilters);
	const productMaterialsList = useSelector(getProductMatrials);
	const [showConfirmation, setShowConfirmation] = useState(false);
	const [selectedMaterial, setSelectedMaterial] = useState(null);
	const userInfo = getUserInfo();
	const { data: matchingCount, refetch } = useGetMachingCountQuery(`?productId=${id}`);

	let collections = useSelector(getAllCollections);
	collections = collections.map((item) => {
		return {
			id: item.id,
			value: item.collectionName
		};
	});

	let brands = useSelector(getAllBrands);
	brands = brands.map((item) => {
		return {
			id: item.id,
			text: item.name,
			value: item.name,
			label: item.name
		};
	});

	useEffect(() => {
		if (selectedType === 'FABRIC') {
			fetchTags();
		}
	}, []);
	useEffect(() => {
		if (requestFrom === 'SUPPLIER') {
			setSelectedType(visibleTabs[0]);
		}
	}, [visibleTabs]);

	const onHide = () => setIsHide(!isHide);

	useEffect(() => {
		let { currentPage, totalPages } = materialsData;
		setHasNext(currentPage < totalPages);
		setMaterialLists(materialsData);
	}, [materialsData]);

	useEffect(() => {
		if (requestFrom !== 'SUPPLIER') {
			const getData = setTimeout(() => {
				onApplyClick().finally();
			}, 400);
			return () => clearTimeout(getData);
		}
	}, [commonFilters, isInventory, selectedType]);

	useEffect(() => {
		setMaterialLists({
			data: [],
			totalElements: 0
		});
		dispatch({
			type: actionTypes.FETCH_ALL_SUPPLIERS_MATERIALS_SUCCESS,
			payload: {
				data: [],
				hasNext: 0
			}
		});
		// setIsLoading(true);
		if ([MATERIALS_TYPE.TRIMS_ACCESSORIES, MATERIALS_TYPE.BRANDING].includes(selectedType)) {
			fetchTagsForTrimsOrAccessories('', MATERIAL_TAG_TYPE.MATERIAL_QUALITY, setMaterialQualityList);
			dispatch(getBrands()).finally(() => {});
		}
		if (selectedType === MATERIALS_TYPE.TRIMS_ACCESSORIES) {
			fetchCategoriesForTrimsOrAccessories('trimsSubCategories', setCategories);
		} else if (selectedType === MATERIALS_TYPE.BRANDING) {
			fetchCategoriesForTrimsOrAccessories('brandingSubCategories', setCategories);
		}
	}, [selectedType]);

	const onSelectForCustomDropDown = (obj, key) => {
		if (obj !== null && obj.value !== null && obj.value.toString().trim() !== '') {
			if (key === MATERIAL_TAG_TYPE.CATEGORY) {
				setSelectedCategories(obj);
				dispatch(setFilters({ ...commonFilters, subCategoryIds: [obj.id] }));
			}
			if (key === MATERIAL_TAG_TYPE.MATERIAL_QUALITY) {
				setSelectedMaterialQuality(obj);
				dispatch(setFilters({ ...commonFilters, materialQualityIds: [obj.id] }));
			}
			if (key === MATERIAL_TAG_TYPE.BRAND) {
				setSelectedSpecificBrand(obj);
				dispatch(setFilters({ ...commonFilters, specificBrandIds: [obj.id] }));
			}
		}
	};

	const fetchSupplierMaterials = async (page) => {
		setIsLoading(true);
		const designEditFabricQuery = `?page=${page}&size=20`;
		setIsApiCallRunning(true);
		if (selectedType !== 'PINNED' && selectedType !== 'MATCHING') {
			let tabName = getTabName(selectedType);
			await dispatch(
				fetchAllSuppliersMaterials(
					page,
					20,
					tabName,
					getSorting(selectedType, isInventory),
					extraSorting(commonFilters, isInventory, id),
					'',
					designEditFabricQuery,
					designEditFabricQuery
				)
			).finally(() => {
				setIsApiCallRunning(false);
				setIsLoading(false);
			});
			dispatch(fetchProductMaterials(id));
		} else {
			if (selectedType === 'PINNED') {
				dispatch(fetchPinnedMaterials({ productId: id })).finally(() => {
					setIsLoading(false);
					setIsApiCallRunning(false);
				});
			} else {
				if (!commonFilters?.search) {
					getPairMaterials();
				}
				setIsLoading(false);
			}
		}
	};

	const getPairMaterials = async () => {
		dispatch(openLoader());
		try {
			const response = await getPairMaterialListForProduct(id);
			const formattedResponse = formatPairMaterialApiResponse(response);
			setMaterialLists({ data: formattedResponse, totalElements: formattedResponse.length });
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		if (selectedType === 'MATCHING' && commonFilters?.search !== undefined) {
			const newMaterials = materialLists?.data?.filter(
				(material) =>
					material?.name?.toLowerCase()?.includes(commonFilters?.search?.toLowerCase()) ||
					material?.referenceNumber?.toLowerCase()?.includes(commonFilters?.search?.toLowerCase())
			);
			setMaterialLists({
				data: newMaterials,
				totalElements: newMaterials?.length
			});
		}
	}, [commonFilters]);

	const scrollRef = useRef(null);

	const handleScroll = () => {
		const wrappedElement = scrollRef.current;
		if (
			Math.abs(
				Math.ceil(wrappedElement.scrollHeight - wrappedElement.scrollTop) -
					wrappedElement.clientHeight
			) <= 5
		) {
			if (hasNext && !isApiCallRunning) {
				fetchSupplierMaterials(page + 1).finally(() => {
					setPage((page) => page + 1);
				});
			}
		}
	};

	useEffect(() => {
		if (selectedType === 'PINNED') {
			setIsLoading(false);
			setMaterialLists({
				data: pinnedMaterials?.materialResponseList,
				totalElements: pinnedMaterials?.materialResponseList?.length
			});
		}
	}, [pinnedMaterials]);

	useEffect(() => {
		dispatch(getCollections(searchCollection));
	}, [dispatch, searchCollection]);

	const getMateialType = (materialType) => {
		if (materialType === 'Trims' || materialType === 'TRIMS') {
			return 'TRIMS';
		} else if (materialType === 'Branding' || materialType === 'BRANDING') {
			return 'BRANDING';
		} else {
			if (productMaterialsList?.length > 0) {
				return 'EXTRA_FABRIC';
			} else {
				return 'MAIN_FABRIC';
			}
		}
	};

	const pinnedStatusUpdated = (e, materialId, isPinned) => {
		e.stopPropagation();
		if (isPinned) addPin(materialId);
		else onRemovePin(materialId);
	};

	const onAddMaterial = async (item) => {
		if (whichUserMaterialBookedCheck()) return;
		setIsAddLoading(true);
		const materialType = getMateialType(item?.materialType);

		let params = `${id}/${item?.materialId}?`;
		params += `&materialType=${materialType}`;

		await ApiClient.POST('addMaterialToProduct', {}, params)
			.then(({ data }) => {
				setIsAddLoading(false);
				if (data) {
					/** updated for basic info */
					dispatch(fetchProductInfo(id));
					dispatch(fetchProductMaterials(id)).finally(() => setIsLoading(false));
				}
				refetch();
			})
			.catch(({ response }) => {
				setIsAddLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const addPin = async (materialId) => {
		// setIsLoading(true);
		await ApiClient.POST('materialPin', {}, `${id}/material/${materialId}/pin`)
			.then(({ data }) => {
				fetchSupplierMaterials(0).finally();
				toastSuccess(data.message);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response.data?.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onRemovePin = async (materialId) => {
		// setIsLoading(true);
		await ApiClient.POST('materialPin', {}, `${id}/material/${materialId}/unpin`)
			.then(() => {
				fetchSupplierMaterials(0).finally();
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onApplyClick = async () => {
		// setIsLoading(true);
		setPage(0);
		await fetchSupplierMaterials(0).finally();
		// onHide();
	};

	const onCloseModal = () => {
		setMaterialModal(false);
	};

	const closeAddModal = (value) => {
		if (value !== undefined && value !== 'Cancel') {
			setPage(0);
			fetchSupplierMaterials(0).finally();
		}
		onCloseModal();
	};

	const onResetClearValue = () => setIsClearAll(false);

	const clearSearch = () => {
		// setIsLoading(true);
		setIsClearAll(true);
		setFinishAndWash([]);
		setCharacteristic([]);
		setSelectedCategories(null);
		setSelectedMaterialQuality(null);
		setSelectedCountry({ id: null, value: 'All' });
		setSelectedSpecificBrand(null);
		refMaterialSearchName.current.value = '';
		dispatch(setFilters(initialFilters));
		if (selectedType !== 'PINNED') {
			dispatch(setFilters({})).finally(() => {
				setIsLoading(false);
			});
		} else {
			dispatch(fetchPinnedMaterials({ productId: id })).finally(() => {
				setIsLoading(false);
			});
		}
	};

	const reNameMaterialsType = (materialType) => {
		if (requestFrom === 'SUPPLIER') {
			if (materialType === MATERIALS_TYPE.TRIMS_ACCESSORIES) {
				return 'TRIMS';
			} else if (materialType === MATERIALS_TYPE.BRANDING) {
				return 'ACCESSORIES';
			} else {
				return materialType;
			}
		} else {
			return materialType;
		}
	};

	const fetchTags = () => {
		ApiClient.GET('fetchFixedTags')
			.then(({ data }) => {
				let characteristicTags = data.filter(
					(item) =>
						item.type === 'SUPPLIER_CHARACTERISTIC_DRAPPY' ||
						item.type === 'SUPPLIER_CHARACTERISTIC_HAND_FEEl' ||
						item.type === 'SUPPLIER_CHARACTERISTIC_FINISH_EFFECT' ||
						item.type === 'SUPPLIER_CHARACTERISTIC_LOOK'
				);

				let finishAndWashTags = data.filter(
					(item) => item.type === 'SUPPLIER_FINISH' || item.type === 'SUPPLIER_WASH'
				);
				setTags({
					characteristic: characteristicTags,
					finishAndWash: finishAndWashTags
				});
			})
			.catch((err) => {
				toastError(err.response.data.message);
			});
	};
	const onChangeFinishWashInfo = (selectedItems) => {
		setFinishAndWash(selectedItems);
	};

	const onChangeCharacteristicInfo = (selectedItems) => {
		setCharacteristic(selectedItems);
	};

	useEffect(() => {
		tagFilteringSet();
	}, [finishAndWash, characteristic]);

	const tagFilteringSet = () => {
		let itemList = [...finishAndWash, ...characteristic];
		let idList = itemList?.map((item) => item.value);
		if (idList.length > 0) {
			onResetClearValue(false);
			dispatch(setFilters({ ...commonFilters, fixedTagIdList: idList }));
		} else {
			dispatch(setFilters({ ...commonFilters, fixedTagIdList: null }));
		}
	};

	const renderTagsField = (tags, placeholder, tagItemList) => {
		let options = tags?.map((item) => ({
			id: item.id,
			text: item.text,
			value: item.id,
			label: item.text
		}));
		if (tagItemList?.length > 0) {
			return (
				<Select
					key={_getKey()}
					onChange={
						placeholder === 'Characteristic' ? onChangeCharacteristicInfo : onChangeFinishWashInfo
					}
					placeholder={placeholder}
					defaultValue={tagItemList}
					isMulti
					options={options}
				/>
			);
		} else {
			return (
				<Select
					key={_getKey()}
					placeholder={placeholder}
					onChange={
						placeholder === 'Characteristic' ? onChangeCharacteristicInfo : onChangeFinishWashInfo
					}
					isMulti
					options={options}
				/>
			);
		}
	};

	const getMaterialAddPermission = () => {
		return (
			selectedType !== 'PINNED' &&
			((checkPrimaryUserType('FASHION_DESIGNER') &&
				(availabilityStatus === 'SOLD' || isBuyerSelected)) ||
				!checkPrimaryUserType('FASHION_DESIGNER'))
		);
	};

	const addMaterialForDesigner = async (item) => {
		if (JSON.stringify(bookedQuantityInfo) === '{}') {
			toastError('Booked Quantity required.');
		} else {
			if (bookedQuantityInfo[item.materialId] !== undefined) {
				if (bookedQuantityInfo[item.materialId] <= item.stockQuantity) {
					setIsAddLoading(true);
					const materialType = getMateialType(item.materialType);

					let params = `${id}/${item.materialId}?`;

					params += `&materialType=${materialType}`;

					params += `&bookedQuantity=${bookedQuantityInfo[item.materialId]}`;
					await ApiClient.POST('addMaterialWithBookedToProduct', {}, params)
						.then(({ data }) => {
							setIsAddLoading(false);
							if (data) {
								/** updated for basic info */
								dispatch(fetchProductInfo(id));
								toastSuccess('Material added');
								// setIsLoading(true);
								dispatch(fetchProductMaterials(id)).finally(() => {
									fetchSupplierMaterials(0).finally(() => setIsLoading(false));
								});
							}
							refetch();
						})
						.catch(({ response }) => {
							setIsAddLoading(false);
							if (response && response.data && response.data.message) {
								toastError(response.data.message);
							} else {
								toastError('Request was unsuccessful.');
							}
						});
					setBookedQuantityInfo({});
				} else {
					toastError('Your booking qty is higher than the inventory balance.');
				}
			} else {
				setBookedQuantityInfo({});
				toastError('Booked Quantity required.');
			}
		}
	};

	const onBookMaterial = (item) => {
		if (item?.isImported) {
			setShowConfirmation(true);
			setSelectedMaterial(item);
		} else {
			addMaterialForDesigner(item);
		}
	};

	const onConfirmBookMaterial = () => {
		addMaterialForDesigner(selectedMaterial);
		setShowConfirmation(false);
		setSelectedMaterial(null);
	};

	const trimsOrAccessoriesFilterRender = () => {
		return (
			<>
				<CustomDropdown
					type="addItem"
					title={'Category'}
					isFocus={true}
					onItemClick={(value) => {
						onSelectForCustomDropDown(value, MATERIAL_TAG_TYPE.CATEGORY);
					}}
					toolTipLength={25}
					items={categories}
					selectedItem={selectedCategories?.value}
				/>
				<div className="mt-4">
					<CustomDropdown
						type="addItem"
						title={'Material quality'}
						isFocus={true}
						onItemClick={(value) => {
							onSelectForCustomDropDown(value, MATERIAL_TAG_TYPE.MATERIAL_QUALITY);
						}}
						toolTipLength={25}
						items={materialQualityList}
						selectedItem={selectedMaterialQuality?.value}
					/>
				</div>
				<div className="mt-4 mb-4">
					<CustomDropdown
						type="addItem"
						title={'Specific brand?'}
						isFocus={true}
						onItemClick={(value) => {
							onSelectForCustomDropDown(value, MATERIAL_TAG_TYPE.BRAND);
						}}
						toolTipLength={25}
						items={brands}
						selectedItem={selectedSpecificBrand?.value}
					/>
				</div>
			</>
		);
	};

	useEffect(() => {
		dispatch(
			setFilters({
				...commonFilters,
				inventoryCountryId: selectedCountry?.id ? [selectedCountry.id] : []
			})
		);
	}, [selectedCountry]);

	const navigateToMaterialDetailsPage = (item, e) => {
		e.stopPropagation();
		const materialType =
			item?.materialType?.toUpperCase() === 'TRIMS'
				? 'TRIMS'
				: item?.materialType?.toUpperCase() === 'BRANDING'
					? 'ACCESSORIES'
					: 'FABRIC';
		const url = `/materials/view/${item.materialId}?type=${materialType}`;
		window.open(url, '_blank');
	};
	return (
		<LoaderComponent loading={isLoading}>
			<div className={`materials-leftbar ${isShowMaterial ? 'show-leftbar' : ''}`}>
				<div className="materials-leftbar-container ">
					<div className="leftbar-header">
						<div className="tags-and-close">
							<div className="tags">
								{visibleTabs.includes('FABRIC') && (
									<span
										className={`tag ${
											selectedType === MATERIALS_TYPE.FABRIC && 'active'
										}`}
										onClick={() => {
											setIsInventory(true);
											setSelectedType(MATERIALS_TYPE.FABRIC);
											dispatch(setFilters(initialFilters));
										}}
									>
										FABRIC
									</span>
								)}
								{visibleTabs.includes(
									reNameMaterialsType(MATERIALS_TYPE.TRIMS_ACCESSORIES)
								) && (
									<span
										className={`tag ${
											selectedType ===
												reNameMaterialsType(MATERIALS_TYPE.TRIMS_ACCESSORIES) &&
											'active'
										}`}
										onClick={() => {
											setIsInventory(true);
											setSelectedType(
												reNameMaterialsType(MATERIALS_TYPE.TRIMS_ACCESSORIES)
											);
											dispatch(setFilters(initialFilters));
										}}
									>
										TRIMS
									</span>
								)}
								{visibleTabs.includes(reNameMaterialsType(MATERIALS_TYPE.BRANDING)) && (
									<span
										className={`tag ${
											selectedType === reNameMaterialsType(MATERIALS_TYPE.BRANDING) &&
											'active'
										}`}
										onClick={() => {
											setIsInventory(true);
											setSelectedType(reNameMaterialsType(MATERIALS_TYPE.BRANDING));
											dispatch(setFilters(initialFilters));
										}}
									>
										ACCESSORIES
									</span>
								)}
								{visibleTabs.includes('MATCHING') && (
									<span
										className={`tag ${selectedType === 'MATCHING' && 'active'}`}
										onClick={() => {
											setSelectedType('MATCHING');
											dispatch(setFilters(initialFilters));
											// dispatch(fetchPinnedMaterials({ productId: id }));
										}}
									>
										MATCHING ({matchingCount})
									</span>
								)}
								{visibleTabs.includes('PINNED') && (
									<span
										className={`tag ${selectedType === 'PINNED' && 'active'}`}
										onClick={() => {
											setSelectedType('PINNED');
											dispatch(setFilters(initialFilters));
											dispatch(fetchPinnedMaterials({ productId: id }));
										}}
									>
										PINNED
									</span>
								)}
							</div>

							<div className="d-flex align-items-center">
								{selectedType !== 'PINNED' && selectedType !== 'MATCHING' && (
									<>
										<button
											className="button inventory-dropdown text-only dropdown-toggle"
											type="button"
											id="dropdownMenuButton"
											data-toggle="dropdown"
											aria-haspopup="true"
											aria-expanded="false"
										>
											{isInventory ? 'Inventory' : 'New arrivals'}
										</button>
										<ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
											<li>
												<span onClick={() => setIsInventory(!isInventory)}>
													{isInventory ? 'New arrivals' : 'Inventory'}
												</span>
											</li>
										</ul>
									</>
								)}
								<div className="close">
									<button
										type="button"
										className="close"
										data-dismiss="modal"
										aria-label="Close"
										onClick={() => onSetShowMaterial(false)}
									>
										<CommonImage src={`/icons/close.svg`} alt="close" />
									</button>
								</div>
							</div>
						</div>

						{selectedType === 'PINNED' && (
							<div className="mb-2">
								<CustomDropdown
									type="addItem"
									title={'Collection'}
									isFocus={true}
									onItemClick={(value) => {
										setSelectedCollectionName(value.value);
										dispatch(fetchPinnedMaterials({ collectionId: value.id })).finally(
											() => {
												setIsLoading(false);
											}
										);
									}}
									toolTipLength={28}
									onItemSearch={(value) => setSearchCollection(value)}
									items={collections}
									selectedItem={selectedCollectionName}
								/>
							</div>
						)}

						{selectedType !== 'PINNED' && (
							<MaterialName
								onHide={onHide}
								type={selectedType}
								refMaterialSearchName={refMaterialSearchName}
							/>
						)}
						{selectedType === 'PINNED' && selectedCollectionName && (
							<button
								className="button mt-2 no-padding"
								onClick={() => {
									dispatch(fetchPinnedMaterials({ productId: id }));
									setSelectedCollectionName('');
								}}
							>
								Reset
							</button>
						)}
					</div>
					{/* Leftbar Content */}
					<div className="leftbar-contents">
						<div className={!isHide ? 'd-none' : ''}>
							{selectedType !== 'PINNED' && (
								<div className="filter-items">
									<div className="title mb-2 pb-1 d-flex align-items-center justify-content-between">
										<h3 className="semibold-14">Filter</h3>
										{/*{isFiter && selectedType !== MATERIALS_TYPE.FABRIC && (*/}
										{/*	<button*/}
										{/*		className="button no-padding"*/}
										{/*		onClick={() => clearSearch()}*/}
										{/*	>*/}
										{/*		Clear*/}
										{/*	</button>*/}
										{/*)}*/}
									</div>
								</div>
							)}
							<div className="filter-items-container">
								{selectedType === reNameMaterialsType(MATERIALS_TYPE.TRIMS_ACCESSORIES) ? (
									trimsOrAccessoriesFilterRender()
								) : selectedType === reNameMaterialsType(MATERIALS_TYPE.BRANDING) ? (
									trimsOrAccessoriesFilterRender()
								) : selectedType === MATERIALS_TYPE.FABRIC ? (
									<>
										<FabricSubCategory
											isClearAll={isClearAll}
											onResetClearValue={onResetClearValue}
											title={'Fabric type'}
										/>
										<div className="mt-4">
											<FabricComposition
												isClearAll={isClearAll}
												onResetClearValue={onResetClearValue}
											/>
										</div>
										<div className="form-group no-shadow-react-select">
											{renderTagsField(
												tags?.finishAndWash,
												'Finish & wash',
												finishAndWash
											)}
										</div>
										<div className="form-group no-shadow-react-select">
											{renderTagsField(
												tags?.characteristic,
												'Characteristic',
												characteristic
											)}
										</div>

										<Gsm isClearAll={isClearAll} onResetClearValue={onResetClearValue} />
										{/* <FabricSpec
                                            isClearAll={isClearAll}
                                            onResetClearValue={onResetClearValue}
                                        /> */}
									</>
								) : (
									''
								)}
								<div className="transparent-select country-dropdown">
									<div className="select-component">
										<label>Inventory location</label>
										<div className="click-box click mb-1">
											<CustomDropdown
												title={'Inventory Location'}
												onItemClick={(selected) => {
													setSelectedCountry(selected);
												}}
												items={[{ id: null, value: 'All' }].concat(
													getCountryList?.map((item) => ({
														id: item.id,
														value: item.name
													}))
												)}
												selectedItem={selectedCountry?.value || ''}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div>
							<div className="filter-items">
								<div className="title mb-2 pb-1 d-flex align-items-center justify-content-between">
									<p className="regular-12 gray_dark_02">
										{materialLists.data?.length > 0
											? materialLists?.totalElements + ' ' + getTabName(selectedType)
											: ''}
									</p>
									{selectedType !== 'PINNED' && (
										<button className="button no-padding" onClick={() => clearSearch()}>
											Clear
										</button>
									)}
								</div>
							</div>
							{/*)}*/}
							<LoaderComponent loading={isAddLoading}>
								{materialLists.data?.length > 0 ? (
									<div
										className={`material-showed-items scroll-y-label ${
											selectedType === 'PINNED' && 'pinned-material-showed'
										}`}
										ref={scrollRef}
										onScroll={handleScroll}
									>
										{materialLists?.data?.map((item, index) => {
											const consumptionUnit = item?.trimsAndBrandingTableResponse
												? getConsumptionUnitForTrimsAccessories(item)
												: getConsumptionShortUnit(item);
											return (
												<div className="single-materials" key={item.materialId}>
													<div className="material-img">
														<CommonImage
															src={
																item?.docUrl
																	? item?.docUrl
																	: `/images/fabric-default.png`
															}
															alt="item"
															className={
																'material-image' +
																(whichUserMaterialBookedCheck()
																	? ''
																	: ' cursor-pointer')
															}
															onClick={(e) => {
																e.stopPropagation();
																if (
																	requestFrom &&
																	requestFrom === 'SUPPLIER'
																) {
																	callback(item.materialId);
																} else {
																	onAddMaterial(item);
																}
															}}
															isStatic={item?.docUrl ? false : true}
														/>
														{item?.isImported && (
															<div className="material-tags">
																<ImportedTag />
															</div>
														)}
													</div>
													<div
														className={
															'm-description' +
															(whichUserMaterialBookedCheck()
																? ''
																: ' cursor-pointer')
														}
														onClick={(e) => {
															e.stopPropagation();
															if (requestFrom && requestFrom === 'SUPPLIER') {
																callback(item.materialId);
															} else {
																onAddMaterial(item);
															}
														}}
													>
														<div className="d-flex justify-content-between align-items-center mt-2 mb-2">
															<p className="material-reference-number regular-12 gray_dark_01 weight-500">
																<span
																	className="code"
																	onClick={(e) =>
																		navigateToMaterialDetailsPage(item, e)
																	}
																>
																	{item.referenceNumber}
																</span>
																<span className="ml-2">
																	<CountryFlag
																		countryId={
																			item?.inventoryCountryResponse?.id
																		}
																	/>
																</span>
															</p>
															{!item?.isExpired && !item?.isLowQuantity && (
																<span
																	className={
																		item?.stockQuantity > 0
																			? 'inventory-value'
																			: 'inventory-value empty'
																	}
																>
																	{item?.stockQuantity
																		? parseFloat(item?.stockQuantity)
																				.toFixed(2)
																				.replace('.00', '') +
																			' ' +
																			consumptionUnit
																		: ''}
																</span>
															)}
															{item?.isExpired && (
																<span className="expired status radius red">
																	Expired: {item?.expiredStockQuantity}
																	&nbsp;
																	{consumptionUnit}
																</span>
															)}
															{item?.isLowQuantity && (
																<span className="expired status radius red">
																	Low Qty: {item?.expiredStockQuantity}
																	&nbsp;
																	{consumptionUnit}
																</span>
															)}
														</div>
														<Tooltip
															title={setCardNameInfo(
																item,
																getTabName(selectedType)
															)}
															placement="top"
															arrow
														>
															<p className="material-name regular-12 gray_dark_01 mb-1">
																{getShortName(
																	setCardNameInfo(
																		item,
																		getTabName(selectedType)
																	),
																	60
																)}
															</p>
														</Tooltip>
													</div>
													{(selectedType === 'PINNED' ||
														selectedType === 'MATCHING') && (
														<p className="regular-12 mb-1">{item?.name}</p>
													)}
													<AddedColors
														colorGroupResponseList={
															item?.materialColorResponse
																?.colorGroupResponseList
														}
														colorResponse={
															Object.keys(
																item.materialColorResponse.colorResponse
															).length > 0
																? item?.materialColorResponse?.colorResponse
																: undefined
														}
														colorType={
															item?.materialColorResponse?.colorType?.name
														}
														viewType={'cardView'}
													/>
													{isShowPin && (
														<>
															{selectedType !== 'PINNED' ? (
																<div
																	className={
																		item.isPinned
																			? 'pin-status pinned'
																			: 'pin-status'
																	}
																	onClick={(e) =>
																		pinnedStatusUpdated(
																			e,
																			item.materialId,
																			!item.isPinned
																		)
																	}
																>
																	<CommonImage
																		src={
																			item.isPinned
																				? `/icons/Pinned-dark-with-bg.svg`
																				: `/icons/Pin-dark-with-bg.svg`
																		}
																		alt="pin"
																	/>
																</div>
															) : (
																<div
																	className="pin-status"
																	onClick={(e) =>
																		pinnedStatusUpdated(
																			e,
																			item.materialId,
																			false
																		)
																	}
																>
																	<CommonImage
																		src={`/icons/Pinned-dark-with-bg.svg`}
																		alt="pin"
																	/>
																</div>
															)}
														</>
													)}
													{!item?.isLowQuantity &&
														whichUserMaterialBookedCheck() &&
														item.stockQuantity > 0 && (
															<div className="add-quantity">
																<div className="input-qty d-flex">
																	<input
																		type="number"
																		placeholder="Qty"
																		name={'bookedQuantity' + index}
																		id={'bookedQuantity' + index}
																		min={0}
																		onKeyDown={validateFloatNumber}
																		value={
																			bookedQuantityInfo[
																				item.materialId
																			] === undefined
																				? ''
																				: bookedQuantityInfo[
																						item.materialId
																					]
																		}
																		onChange={(e) =>
																			setBookedQuantityInfo({
																				[item.materialId]:
																					e.target.value
																			})
																		}
																	/>

																	<p className="regular-14 gray_dark_01 text-uppercase unit">
																		{item?.trimsAndBrandingTableResponse
																			? getConsumptionUnitForTrimsAccessories(
																					item
																				)
																			: getConsumptionShortUnit(item)}
																	</p>
																</div>
																<button
																	className="button size32"
																	onClick={() => onBookMaterial(item)}
																	disabled={
																		item?.isReserved &&
																		userInfo?.nickName !==
																			item?.reservedFor
																	}
																>
																	Book
																</button>
															</div>
														)}
													{item?.isReserved &&
														userInfo?.nickName !== item?.reservedFor && (
															<RestrictedInfo item={item} />
														)}
												</div>
											);
										})}

										{getMaterialAddPermission() && (
											<div className="material-fixed-btn">
												<button
													className="button text size36"
													onClick={() => setMaterialModal(true)}
												>
													<CommonImage
														src={`/icons/add-round.svg`}
														alt={`/icons/add-round.svg`}
													/>
													<span>Material</span>
												</button>
											</div>
										)}
									</div>
								) : (
									<p className="no-material">No material found</p>
								)}
							</LoaderComponent>
						</div>
					</div>
				</div>
			</div>
			{requestFrom !== 'SUPPLIER' && showMaterialModal && MATERIALS_TYPE.FABRIC === selectedType && (
				<AddFabric
					isShow={true}
					onCloseModal={onCloseModal}
					productId={id}
					isMainFabric={isMainFabric}
				/>
			)}
			{requestFrom === 'SUPPLIER' && showMaterialModal && MATERIALS_TYPE.FABRIC === selectedType && (
				<Fabric
					materialData={null}
					isShow={true}
					onclose={closeAddModal}
					viewType={'EDIT'}
					renderFrom={'MATERIAL'}
					isAdd={true}
				/>
			)}

			{showMaterialModal && reNameMaterialsType(MATERIALS_TYPE.TRIMS_ACCESSORIES) === selectedType && (
				<TrimsAndAccessories
					isAdd={true}
					renderFrom={enumObj.DESIGNS}
					viewType={'Add'}
					title={MATERIAL_TITLE_NAME.TRIMS}
					isShow={true}
					onclose={closeAddModal}
					productId={id}
				/>
			)}

			{showMaterialModal && reNameMaterialsType(MATERIALS_TYPE.BRANDING) === selectedType && (
				<TrimsAndAccessories
					isAdd={true}
					renderFrom={enumObj.DESIGNS}
					viewType={'Add'}
					title={MATERIAL_TITLE_NAME.BRANDING}
					isShow={true}
					onclose={closeAddModal}
					productId={id}
				/>
			)}
			{showConfirmation && (
				<ModalContainer className="book-alart-modal">
					<div className="common-popup alart-modal">
						<div className="common-popup-body">
							<div className="book-alart">
								<p className="gray_dark_01 regular-14">
									{/* You can use “imported” fabric in the Create & Collaborate (C&C) collection
									or in a buyer development collection only. Otherwise, your techpack will
									be returned to you to change the imported fabric. */}
									You have selected an imported fabric. If you are creating a P&C design
									please change to a local fabric.
								</p>
							</div>
						</div>
					</div>
					<div className="modal-footer border-0">
						<div className="footer-buttons text-right">
							<button
								className="button gray-outline size32 ml-2"
								onClick={() => setShowConfirmation(false)}
							>
								Cancel
							</button>
							<button className="button  approve size32 ml-2" onClick={onConfirmBookMaterial}>
								I understand
							</button>
						</div>
					</div>
				</ModalContainer>
			)}
		</LoaderComponent>
	);
};

export default MaterialsLeftPanel;
